const maximumHardwareLength = 255;

const maximumTaxNumberLength = 13;

const maximumVatIdentificationLength = 30;

const minCountPointsOfSales = 1;

const maxCountPointsOfSales = 10000;


export {
    maximumHardwareLength,
    maximumTaxNumberLength,
    maximumVatIdentificationLength,
    minCountPointsOfSales,
    maxCountPointsOfSales
}
